export default __webpack_public_path__ + "static/media/ASThermal-Regular.c705e949.woff2";